import camelizeKeys from './camelizeKeys';

export function parseJsonApi(response, type) {
  return (response.data.included || [])
    .concat(Array.isArray(response.data.data) ? response.data.data : [response.data.data])
    .filter(item => item.type === type)
    .reduce((previousValue, currentValue) => {
      const value = { ...previousValue };

      value[currentValue.id] = {
        id: currentValue.id,
        ...camelizeKeys(currentValue.attributes),
      };

      if (currentValue.relationships) {
        const relationships = camelizeKeys(currentValue.relationships);
        Object.keys(relationships).forEach((key) => {
          const relationship = relationships[key].data;

          if (Array.isArray(relationship)) {
            value[currentValue.id][key] = relationship.map(item => item.id);
          } else {
            value[currentValue.id][key] = relationship.id;
          }
        });
      }

      return value;
    }, {});
}
